

import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/react";

Sentry.init({
  dsn: "https://76d27b9962345184bced67887b7b128c@o4510993579442176.ingest.de.sentry.io/4510993657430096",
  integrations: [browserTracingIntegration()],
  tracesSampleRate: 1.0,
});


import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
